import { Box, Button, Grid, Typography } from "@mui/material";

import styles from "./HeroBlock.module.css";

import { ReactComponent as EyeIcon } from "@/assets/svg/eye.svg";
import { ReactComponent as LockIcon } from "@/assets/svg/lock.svg";
import { ReactComponent as MailIcon } from "@/assets/svg/mail.svg";

const HeroBlock = ({
  onGetStartedClick,
}: {
  onGetStartedClick: () => void;
}) => {
  return (
    <Box className={styles.wrapper}>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs={12} md={7.5}>
          <Typography variant="h3" className={styles.title}>
            Security Awareness Training
          </Typography>
          <Typography variant="body1" className={styles.description}>
            Explore interactive topics and quizzes to strengthen your knowledge
            of information security. From phishing and passwords to mobile
            threats, build the skills to protect yourself and your company.
          </Typography>
          <Button
            variant="contained"
            className={styles.button}
            onClick={onGetStartedClick}
          >
            Get Started
          </Button>
        </Grid>

        <Grid item xs={12} md={4.5} className={styles.iconsWrapper}>
          <EyeIcon className={styles.eyeIcon} />
          <LockIcon className={styles.lockIcon} />
          <MailIcon className={styles.mailIcon} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeroBlock;
